export class SendInfoConsulta {
    constructor() {
        return {
            send: (data, url) => {
                return this.send(data, url)
            },
            getInfo: () => {
                return this.getInfo()
            },
            setToken: (token) => {
                return this.setToken(token)
            }
        }
    }

    async send (data, url) {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({
                'cpf': data.cpf,
                'data_nascimento': data.dataNascimento,
                'matricula': data.matricula,
                'token': data.token
            }),
            headers: new Headers({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }),
        };
        return await fetch(process.env.REACT_APP_URL_API + url, requestOptions);
    }

    getInfo() {
        const data = JSON.parse(localStorage.getItem('data_consulta'))
        return {
            cpf: data.cpf,
            dataNascimento: data.dataNascimento,
            matricula: data.matricula,
            token: data.token
        }
    }

    setToken(token) {
        return {
            cpf: '',
            dataNascimento: '',
            matricula: '',
            token: token
        }
    }
}
